import { useState } from 'react';
import type { Compromisso } from '../lib/api.ts';
import { ROTULOS_TIPO, paraTela } from '../lib/datas.ts';
import { usarEhMaster } from '../lib/papel.ts';
import { Confirmar } from './Confirmar.tsx';
import { Icone } from './Icone.tsx';

type Props = {
  compromisso: Compromisso;
  atrasado?: boolean;
  /** Na lista do celular a data já é o cabeçalho do dia — não repetir. */
  semData?: boolean;
  aoConcluir: () => void;
  aoDesmarcar: () => void;
  aoEditar: () => void;
  aoApagar: () => void;
  /**
   * ⭐ **Sistema visual 2026 — 14/09/2026, parte 4 (tela Hoje).** Na `linha`,
   * editar e apagar viram ícones com o nome falado, como os contatos da ficha.
   * Sem ele, fica como era — o Calendário muda só na parte dele.
   */
  desenho?: 'linha';
};

export function ItemCompromisso({
  compromisso,
  atrasado = false,
  semData = false,
  aoConcluir,
  aoDesmarcar,
  aoEditar,
  aoApagar,
  desenho,
}: Props) {
  const [confirmando, setConfirmando] = useState(false);
  // Concluir e desmarcar continuam para todo mundo: dizer que a entrega saiu é
  // o trabalho do dia. Corrigir e apagar são do master.
  const ehMaster = usarEhMaster();

  return (
    <>
      {/* ⭐ **A janelinha da casa — 19/09/2026.** Era um "Apagar? Sim · Não" na
          própria linha, sem dizer o que sai. Agora pergunta como todo apagar
          do Hub. */}
      {confirmando && (
        <Confirmar
          titulo="Apagar este compromisso?"
          descricao={`${compromisso.titulo} sai do calendário e da tela Hoje, e não volta.`}
          aoConfirmar={aoApagar}
          aoFechar={() => setConfirmando(false)}
        />
      )}
      <div
        className={
          'item' +
          (desenho === 'linha' ? ' item-linha' : '') +
          (atrasado ? ' item-atrasado' : '') +
          (compromisso.concluido ? ' item-feito' : '')
        }
      >
        <div className="item-marca">
          <input
            type="checkbox"
            className="item-caixa"
            checked={compromisso.concluido}
            onChange={() => (compromisso.concluido ? aoDesmarcar() : aoConcluir())}
            aria-label={compromisso.concluido ? 'Desmarcar' : 'Marcar como concluído'}
          />
        </div>

        <div className="item-corpo">
          <p className="item-titulo">{compromisso.titulo}</p>
          <p className="item-meta">
            <span className={'etiqueta etiqueta-' + compromisso.tipo}>
              {ROTULOS_TIPO[compromisso.tipo]}
            </span>
            {!semData && <span className="dado">{paraTela(compromisso.data)}</span>}
            {compromisso.concluido && compromisso.concluidoPor && (
              <span className="item-feito-por">feito por {compromisso.concluidoPor.nome}</span>
            )}
          </p>
          {compromisso.observacao && <p className="item-observacao">{compromisso.observacao}</p>}
        </div>

        <div className="item-acoes">
          {!ehMaster ? null : desenho === 'linha' ? (
            <>
              <button
                type="button"
                className="s-acao s-acao-icone"
                onClick={aoEditar}
                aria-label={`Editar ${compromisso.titulo}`}
                title="Editar"
              >
                <Icone nome="lapis" tamanho={15} />
              </button>
              <button
                type="button"
                className="s-acao s-acao-icone perigo"
                onClick={() => setConfirmando(true)}
                aria-label={`Apagar ${compromisso.titulo}`}
                title="Apagar"
              >
                <Icone nome="lixeira" tamanho={15} />
              </button>
            </>
          ) : (
            <>
              <button type="button" className="botao-texto" onClick={aoEditar}>
                Editar
              </button>
              <button
                type="button"
                className="botao-texto botao-perigo"
                onClick={() => setConfirmando(true)}
              >
                Apagar
              </button>
            </>
          )}
        </div>
      </div>
    </>
  );
}
